// extracted by mini-css-extract-plugin
module.exports = {"singleDatepicker":"_2JaWE","datepickerSplitter":"_2rke7"};